/* global axios */
import ApiClient from './ApiClient';

class AiKnowledgeAPI extends ApiClient {
  constructor() {
    super('ai_knowledge_entries', { accountScoped: true });
  }

  list(params = {}) {
    return axios.get(this.url, { params });
  }

  save(payload) {
    return axios.post(this.url, { ai_knowledge_entry: payload });
  }

  patch(id, payload) {
    return axios.patch(`${this.url}/${id}`, { ai_knowledge_entry: payload });
  }

  remove(id) {
    return axios.delete(`${this.url}/${id}`);
  }

  mine() {
    return axios.post(`${this.url}/mine`);
  }
}

class AiExamplesAPI extends ApiClient {
  constructor() {
    super('ai_examples', { accountScoped: true });
  }

  list(params = {}) {
    return axios.get(this.url, { params });
  }

  patch(id, payload) {
    return axios.patch(`${this.url}/${id}`, { ai_example: payload });
  }

  bulk(ids, status) {
    return axios.post(`${this.url}/bulk_update`, { ids, status });
  }

  remove(id) {
    return axios.delete(`${this.url}/${id}`);
  }
}

export const aiExamplesAPI = new AiExamplesAPI();
export default new AiKnowledgeAPI();
